import { render, staticRenderFns } from "./DashboardYoube.vue?vue&type=template&id=629ea698&"
import script from "./DashboardYoube.vue?vue&type=script&lang=js&"
export * from "./DashboardYoube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports